"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const next12_components_text_info_n_1 = __importDefault(require("@gcloud-npm/next12.components.text-info-n"));
const next12_utils_enums_colors_1 = __importDefault(require("@gcloud-npm/next12.utils.enums.colors"));
const next12_components_icon_n_1 = __importDefault(require("@gcloud-npm/next12.components.icon-n"));
const react_redux_1 = require("react-redux");
const next12_app_controller_reducers_sagas_modals_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer");
const next12_components_button_n_1 = __importDefault(require("@gcloud-npm/next12.components.button-n"));
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const next12_app_controller_reducers_sagas_main_reducer_r_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-r");
const next12_components_simple_form_1 = __importDefault(require("@gcloud-npm/next12.components.simple-form"));
const close_button_1 = __importDefault(require("../close-button"));
const CP_REGEX = new RegExp("^[0-9]{5}$");
class CPModal extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleZoneChange = ({ persist = false }) => {
            const { setCpParams, municipiosPosibles } = this.props;
            const cpInputValue = document.getElementById("cp").value;
            this.cpInput = cpInputValue;
            const municipioValue = (document.getElementById("municipio") &&
                document.getElementById("municipio").value) ||
                "";
            if (municipioValue && municipioValue.indexOf("||") > 0) {
                const tokkens = municipioValue.split("||");
                setCpParams({
                    municipio: tokkens[0],
                    cp: this.cpInput,
                    zone: tokkens[1],
                    businessZones: municipiosPosibles,
                    persist,
                });
            }
        };
        this.handleCpChange = () => {
            const { checkCPAndSetZones } = this.props;
            const cpInputValue = document.getElementById("cp").value;
            this.cpInput = cpInputValue;
            const check = CP_REGEX.test(cpInputValue);
            if (check && checkCPAndSetZones) {
                checkCPAndSetZones({ cp: cpInputValue });
            }
            this.setState({ error: !check });
        };
        this.buttonClick = () => {
            this.handleZoneChange({ persist: true });
            this.closeModal();
        };
        this.closeModal = () => {
            const { addModal } = this.props;
            addModal({
                id: "closeAll",
            });
        };
        this.drawModal = () => {
            try {
                const device = (0, next12_utils_common_1.getDeviceKindDependsOnViewPort)();
                if (device === "mobile") {
                    const modalParent = document.querySelector(".modal-root");
                    modalParent.style.zIndex = "35";
                    modalParent.style.top = "0px";
                }
                else {
                    const positiontop1 = document.querySelector(".header .header1-main").clientHeight;
                    const positiontop2 = document.querySelector(".header .header2-nav").clientHeight;
                    const modalParent = document.querySelector(".modal-root");
                    modalParent.style.zIndex = "35";
                    modalParent.style.height = `calc(100vh - ${parseInt(positiontop1 + positiontop2, 10)}px)`;
                    modalParent.style.top = `${parseInt(positiontop1 + positiontop2, 10) - 10}px`;
                }
            }
            catch (err) {
                console.error(err);
            }
        };
        const { cp } = props;
        this.cpInput = cp;
        this.state = {
            cpInput: cp,
            error: false,
        };
    }
    componentDidMount() {
        const { checkCPAndSetZones } = this.props;
        this.drawModal();
        checkCPAndSetZones({ cp: this.cpInput, needBussinesZone: true });
    }
    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }
    componentWillUnmount() {
        const modalParent = document.querySelector(".modal-root");
        modalParent.style.removeProperty("z-index");
        modalParent.style.removeProperty("top");
        modalParent.style.removeProperty("height");
    }
    render() {
        const { error } = this.state;
        const { cp, municipiosPosibles, municipio, checkedCpByApi } = this.props;
        let i = 0;
        const colorBlue = (0, next12_utils_enums_colors_1.default)("BLUE");
        const colorGrey1 = (0, next12_utils_enums_colors_1.default)("GREY1");
        const itemsM = municipiosPosibles
            ? Object.values(municipiosPosibles)
            : null;
        return (react_1.default.createElement("div", { className: "header-modal-cp", "data-cy": "Header modal CP" },
            react_1.default.createElement("div", { className: "close" },
                react_1.default.createElement(close_button_1.default, { onClick: this.closeModal, color: colorBlue, backgroundColor: "white", onHoverColor: colorGrey1, taggingInfo: {
                        componentName: "header",
                        componentContent: "closeCP",
                        componentVariation: "all",
                        componentPerso: "",
                        componentProduct: "",
                    } })),
            react_1.default.createElement(next12_components_simple_form_1.default, { id: "cpForm", autoComplete: false, onSubmit: this.handleCpChange },
                react_1.default.createElement(next12_components_text_info_n_1.default, { text: "C\u00F3digo postal", fontType: "font-regular", size: "title06", color: "grey6", display: "block", cyData: "Header modal CP title" }),
                react_1.default.createElement(next12_components_text_info_n_1.default, { text: "Te mostraremos la oferta disponible", fontType: "font-regular", size: "caption01", color: "grey5", display: "block" }),
                react_1.default.createElement(next12_components_text_info_n_1.default, { text: "C\u00F3digo postal", fontType: "font-regular", size: "caption02", color: "grey4", className: "cp-description" }),
                react_1.default.createElement("input", { type: "text", id: "cp", className: `cp-text${error ? " invalid" : ""}`, name: "cp", maxLength: "5", minLength: "5", defaultValue: cp, required: true, autoComplete: "off", onBlur: this.handleCpChange, onChange: this.handleCpChange, "data-cy": "Header modal CP input" })),
            react_1.default.createElement(next12_components_simple_form_1.default, { autoComplete: false, onSubmit: this.handleZoneChange },
                itemsM && itemsM.length === 1 && (react_1.default.createElement("input", { id: "municipio", type: "hidden", value: `${itemsM[0].geographicAreaName}||${itemsM[0].businessZoneName}` })),
                itemsM && itemsM.length > 1 && (react_1.default.createElement("div", { className: "municipios" },
                    react_1.default.createElement(next12_components_text_info_n_1.default, { text: "Hay varios municipios con ese c\u00F3digo postal", fontType: "font-regular", size: "caption01", color: "grey5", display: "block" }),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "select-icon" },
                            react_1.default.createElement(next12_components_icon_n_1.default, { id: "cheuron-down", kind: "M", size: 14, color: "blue" })),
                        react_1.default.createElement(next12_components_text_info_n_1.default, { text: "Municipio de instalaci\u00F3n", fontType: "font-regular", size: "caption02", color: "grey4", display: "block", className: "cp-description" }),
                        react_1.default.createElement("select", { id: "municipio", name: "select", className: "cp-select", required: true, onChange: this.handleZoneChange, "data-cy": "Header modal CP select" },
                            react_1.default.createElement("option", { value: "value0", disabled: true }, "Selecciona un municipio"),
                            itemsM.map((item) => {
                                const selected = item.geographicAreaName === municipio;
                                console.log({ item, selected });
                                return (react_1.default.createElement("option", { key: `item-${i++}`, value: `${item.geographicAreaName}||${item.businessZoneName}`, selected: selected }, item.geographicAreaName));
                            }))))),
                react_1.default.createElement("div", { className: "button-container" },
                    react_1.default.createElement(next12_components_button_n_1.default, { onClick: this.buttonClick, label: "Aceptar", buttonType: "primary", height: "normal", width: "medium", disabled: error || !checkedCpByApi, taggingInfo: {
                            componentName: "header",
                            componentVariation: "all",
                            componentContent: "aceptarCP",
                            componentPerso: "",
                            componentProduct: "",
                        }, cyData: "Header modal CP button" })))));
    }
}
const mapStateToProps = (state) => ({
    cp: state.main.cp,
    zone: state.main.zone,
    municipio: state.main.municipio,
    municipiosPosibles: state.main.municipiosPosibles,
    checkedCpByApi: state.main.checkedCpByApi,
});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next12_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
    setCpParams: (data) => dispatch(next12_app_controller_reducers_sagas_main_reducer_r_1.actions.setCpParams(data)),
    checkCPAndSetZones: (data) => dispatch(next12_app_controller_reducers_sagas_main_reducer_r_1.actions.checkCPAndSetZones(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(CPModal);
//# sourceMappingURL=index.js.map